import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GetConnectedCompanyIntegrationsEffects } from './get-connected-company-integrations.effects';
import { reducer } from './get-connected-company-integrations.reducers';

@NgModule({
  imports: [
    EffectsModule.forFeature([ GetConnectedCompanyIntegrationsEffects ]),
    StoreModule.forFeature('getConnectedCompanyIntegrations', reducer),
  ],
})
export class GetConnectedCompanyIntegrationsModule {
}
